// extracted by mini-css-extract-plugin
export default {"container":"Compass_container__kZxSU","rotated":"Compass_rotated__qDyH+"};